// removed by extract-text-webpack-plugin
module.exports = {"toggle":"_2lChr","selected":"_3MRMF"};


//////////////////
// WEBPACK FOOTER
// ./components/Toggle.css
// module id = 475
// module chunks = 3 4 5